import React from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer'
import GetInTouch from '../component/GetInTouch/GetInTouch'
import TextContent from '../component/TextContent/TextContent'
import OccupiedStagging from '../component/OccupiedStagging/OccupiedStagging'
import { Helmet } from 'react-helmet'

function Design3() {
    return (
        <>
          {/* <Helmet>
            <title> 
            Professional Commercial, Residential Interior Decorating Services Canada 
            </title>
            <meta 
            name='description' 
            content="Transform your business environment with MES Décors' expert commercial residential interior decorating services in Canada. Boost productivity, customer satisfaction, and revenue." 
            />
<link rel="canonical" href="https://www.mesdecors.ca/commercial" />

            </Helmet> */}
        
            <HeroBanner 
                subHeading=""
                Heading="DESIGN 3"
                nextLineSpanHeading=""
                Paragraph=""
                bgImg="/images/creatives/commercial-hero-bg.jpg"
                btn={false}
                sideLinks={false}
            />
    
    <TextContent
      subHeading="Lorem ipsum dolor sit amet"
      heading="Lorem Ipsum Dolor Sit Amet"
      content={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Phasellus efficitur, lectus eget auctor volutpat, ligula est consequat arcu, non gravida erat arcu nec velit. Integer consequat ligula vel turpis pharetra, vel aliquet turpis malesuada.`}
      btn={true}
      btnText="Get A QUOTE"
      btnRef='/get-a-quote'
      btnRefTel={false}
      shiftRow={false}
      img="/images/creatives/commercial-text-1.jpg"
      reviewContent={false}
      btnImg={false}
      fontDark={true}
  />

    <OccupiedStagging
        heading="Lorem Ipsum Dolor Sit Amet"
        content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Morbi in urna eget odio ultrices convallis at vel dui."
        card1={{
            title:"Lorem Ipsum",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur."
        }}
        card2={{
            title:"Lorem Ipsum",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur."
        }}
        card3={{
            title:"Lorem Ipsum",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur."
        }}
      
    />

        <OccupiedStagging
            heading="Lorem Ipsum Dolor Sit Amet"
            content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Phasellus efficitur, lectus eget auctor volutpat, ligula est consequat arcu, non gravida erat arcu nec velit."
            card1={{
                title:"Lorem Ipsum",
                content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean vestibulum, nisi eget molestie convallis, urna justo bibendum orci, eget aliquet ligula risus id lacus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur."
            }}
            card2={{
                title:"Lorem Ipsum",
                content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean vestibulum, nisi eget molestie convallis, urna justo bibendum orci, eget aliquet ligula risus id lacus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur."
            }}
            card3={{
                title:"Lorem Ipsum",
                content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean vestibulum, nisi eget molestie convallis, urna justo bibendum orci, eget aliquet ligula risus id lacus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla purus vel velit facilisis, at interdum mauris auctor. Curabitur ac lorem risus. Vestibulum euismod turpis eget libero fermentum, at aliquam purus efficitur."
            }}
            
            lightTheme={true}
        />

            {/* <TextContent
                subHeading=""
                heading= "THE ART OF STAGING"
                content={`Vacant homes can often feel cold and uninviting, making it hard for potential buyers to envision their lives there. At MES Décors, we specialize in the art of vacant staging, transforming empty spaces into warm, welcoming environments.\n Our team carefully selects and arranges furniture, artwork, and accessories to highlight each room's potential and charm. By creating a lived-in feel, we help buyers connect emotionally with the space, increasing the likelihood of a quick and profitable sale. Let us turn your vacant property into a buyer's dream home.`}
                btn={true}
                btnText="Get A QUOTE"
                btnRef='/get-a-quote'
                btnRefTel={false}
                shiftRow={true}
                img="/images/creatives/home-owner-text-2.jpg"
                reviewContent={false}
                btnImg={false}
                fontDark={true}
            /> */}
           
          <GetInTouch
            heading='Let’s Start Staging Today!'
          />
          <Footer
            newsletterSection={true}
          />
        </>
      )
}

export default Design3